export default function nextImageUrl(url: string, width = 2048, quality = 75) {
  return `/_next/image?url=${url}&w=${width}&q=${quality}`;
}
